// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Meta from 'vue-meta'
import store from './store/store'

// import "bootstrap/dist/js/bootstrap.js";

import '../static/website/css/bootstrap.min.css'
import '../static/website/css/style.css'; 
import '../static/website/css/responsive.css';




window.Vue = Vue
Vue.config.productionTip = false

//window.$ = require('jquery')

Vue.use(Meta)

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

var SocialSharing = require('vue-social-sharing');
Vue.use(SocialSharing); 

import VueFeather from 'vue-feather';
Vue.use(VueFeather);

import VueCookies from 'vue-cookies'
Vue.use(VueCookies);

Vue.prototype.$env_var = process.env

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js